export function createCSSVariables(object, prefix, platform, theme) {
  const tokens = {};
  Object.keys(object).forEach(token => {
    const value = object[token][theme === 'light' ? `${platform}Value` : `${platform}DarkValue`];
    if (value) {
      tokens[`${prefix}-${token}`] = value;
    }
  });
  return tokens;
}